import {create} from "zustand";
import {persist} from "zustand/middleware";

export interface UiState {
    sidebarOpen: boolean;
    sidebarWidth: number;
    openSidebar: () => void,
    closeSidebar: () => void,
}

export const useUiState = create<UiState>()(
    persist(
        set => ({
            sidebarOpen: true,
            sidebarWidth: 240,
            openSidebar: () => set({sidebarOpen: true}),
            closeSidebar: () => set({sidebarOpen: false}),
        }),
        {
            name: 'ui-storage',
        }
    )
);